exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-range-filter__label[data-v-38abac62]{display:block;margin-bottom:4px;font-size:12px;color:#4e5560}.date-range-filter__inputs[data-v-38abac62]{display:flex;align-items:center;gap:6px}.date-range-filter__inputs .form-control[data-v-38abac62]{width:150px;height:34px;font-size:12px}.date-range-filter__sep[data-v-38abac62]{font-size:12px;color:#9ca0a7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38abac62","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/default/dateRangeFilter.vue
// module id = 900
// module chunks = 0